export enum EventsEnum {
  DISCONNECT = "disconnect",
  CONNECT = "'connect",
  CONNECT_ERROR = "connect_error",
  ERROR = "error",
  DRIVER_HEARTBEAT = "driver-heartbeat",


  // MARK: CORRIDA
  REQUEST_RIDE = "request-ride",
  ACCEPT_RIDE_START = "accept-ride-start",
  RIDE_REQUEST = "ride-request",
  RIDE_ACCEPT = "ride-accept",
  RIDE_REJECTED = "ride rejected",
  RIDE_REQUEST_RESPONSE = "ride-request-response",
  RIDE_ACCEPT_RESPONSE = "ride-accept-response",
  RIDE_STATUS = "ride-status",
  ACCEPT_RIDE = "accept-ride",
  RIDE_UPDATE = "ride-update",
  RIDE_UPDATE_OTP_CHECK = "ride-update-otp-check",
  REACHED_PICKUP = "reached-pickup",
  REACHED_PICKUP_LOCATION = "reached-pickup-location",
  CANCEL_RIDE = "cancel-ride",
  CHANGE_PAYMENT_MODE = "change-payment-mode",
  PAYMENT_COMPLETED = "payment-completed",
  PAYMENT_STATUS = "payment-status",
  CANCEL_RIDE_SUGGEST = "cancel-ride-suggest",
  DRIVER_ONLINE = "driver-online",
  NEW_RIDE_REQUEST = "new-ride-request",
  NEW_RIDE_ACCEPT = "new-ride-accept",
  VALUE_BALANCE = "value-balance",
  VALUE_WALLET = "value-wallet",
  LIVE_LOCATION = "live-location",
  ORDER_REQUEST = "order-request",
  SUGGEST_NEW_FARE = "suggest-new-fare",
  ACCEPT_SUGGEST_RESPONSE = "accept-suggest-response",
  SUGGEST_NEW_RIDE_REQUEST = "suggest-new-ride-request",
  NEW_PRICE_SUGGESTION = "new-price-suggestion",
  CHAT_MESSAGE = "chat-message",
  ALL_CHAT_MESSAGES_SEEN = "all-chat-messages-seen",
  TYPING_INDICATOR = "typing-indicator",
  MESSAGE_DELIVERED = "message-delivered",
  MESSAGE_READ = "message-read",
  NEARBY_DRIVERS = "nearby-drivers",
  RECHARGE_ACCOUNT = "recharge-account",
  RIDE_SUGGEST_ACCEPT = "ride-suggest-accept",
  ACCEPT_SUGGEST = "accept-suggest",
  RIDE_REQUEST_NEW_RIDE = "ride-request-new-ride",
  ACCEPT_NEW_RIDE_REQUEST = "accept-new-ride-request",
  RIDE_COMPLETE = "ride-completed",
  SUGGEST_NEW_FARE_REQUEST = "suggest-new-fare-request",
  PAYMENT_SUCCESS = "payment-success",
  RIDE_SUGGEST_ACCEPT_START = "ride-suggest-accept-start",
  NEERBY_DRIVERS = 'nearby-drivers',
  FARE_REJECTED_TIMEOUT = 'fare-rejected-timeout',
  FARE_NOT_ACCEPTED = 'fare-not-accepted',
  RIDE_REQUEST_ACK = 'ride-request-ack',
  DRIVER_PAUSE = 'driver-pause',
  DRIVER_RESUME = 'driver-resume',
  REQUEST_CANCEL = 'request-cancel',
  CONFIRM_CANCEL = 'confirm-cancel',
  REJECT_CANCEL = 'reject-cancel',
  DISPUTE_MESSAGE = 'dispute-message',
  DISPUTE_STATUS_UPDATE = 'dispute-status-update',
  JOIN_DISPUTE_ROOM = 'join-dispute-room',
}
